import { render, staticRenderFns } from "./AddEmployee.vue?vue&type=template&id=00ed4ce8&scoped=true"
import script from "./AddEmployee.vue?vue&type=script&lang=js"
export * from "./AddEmployee.vue?vue&type=script&lang=js"
import style0 from "./AddEmployee.vue?vue&type=style&index=0&id=00ed4ce8&prod&scoped=true&lang=css"
import style1 from "./AddEmployee.vue?vue&type=style&index=1&id=00ed4ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed4ce8",
  null
  
)

export default component.exports